import type { TFunction } from 'i18next';
import * as yup from 'yup';

export const getCreateEnterpriseOrgBasicTabSchema = (t: TFunction) =>
  yup.object().shape({
    name: yup.string().required(
      t('validation:mandatory', {
        field: t('organizations:layouts.organizations.create.fields.organizationName')
      })
    ),
    legalName: yup.string().nullable(),
    offices: yup.array().min(
      1,
      t('validation:atLeastOne', {
        field: t('organizations:layouts.organizations.create.fields.office')
      })
    ),
    countries: yup.array().min(
      1,
      t('validation:atLeastOne', {
        field: t('organizations:layouts.organizations.create.fields.country')
      })
    )
  });

export const getCreateOrgBasicTabSchema = (t: TFunction) =>
  yup.object().shape({
    name: yup.string().required(
      t('validation:mandatory', {
        field: t('organizations:layouts.organizations.create.fields.organizationName')
      })
    ),
    legalName: yup.string().nullable(),
    offices: yup.string().required(
      t('validation:mandatory', {
        field: t('organizations:layouts.organizations.create.fields.office')
      })
    ),
    countries: yup.string().required(
      t('validation:mandatory', {
        field: t('organizations:layouts.organizations.create.fields.country')
      })
    )
  });

export const getCreateOrgMoreInfoTabSchema = (t: TFunction) =>
  yup.object().shape({
    keyAccountManagers: yup.array().min(
      1,
      t('validation:atLeastOne', {
        field: t('organizations:layouts.organizations.create.fields.keyAccountManagers')
      })
    ),
    locales: yup.array().min(
      1,
      t('validation:atLeastOne', {
        field: t('organizations:layouts.organizations.create.fields.primaryLanguages')
      })
    ),
    jiraId: yup.string().nullable(),
    legacyId: yup.string().nullable(),
    pipedriveId: yup.string().nullable()
  });

export const getCreateOrgAdminsTabSchema = (t: TFunction) =>
  yup.object().shape({
    admin: yup.object().shape({
      email: yup
        .string()
        .email(t('validation:email'))
        .required(
          t('validation:mandatory', {
            field: t('organizations:layouts.organizations.create.fields.adminEmail')
          })
        ),
      phone: yup.string().required(
        t('validation:mandatory', {
          field: t('organizations:layouts.organizations.create.fields.adminPhone')
        })
      )
    })
  });

export const getCreateOrgGlobalSchema = (t: TFunction, isEnterprise: boolean) =>
  isEnterprise
    ? getCreateOrgAdminsTabSchema(t)
        .concat(getCreateOrgMoreInfoTabSchema(t))
        .concat(getCreateEnterpriseOrgBasicTabSchema(t))
    : getCreateOrgAdminsTabSchema(t).concat(getCreateOrgMoreInfoTabSchema(t)).concat(getCreateOrgBasicTabSchema(t));
